module.exports = __webpack_public_path__ + "media/images/weather/21_night_g-8e0acf6fd0d2bfd3c5a164b4cf2329d7.png";